<!--It is created by nikhil 10-09-2020-->
<!--Report Configuration Component-->
<div class="topDiv" [style.background-color]="backgroundColorScreen"
  style="padding: 5px;">

  <div class="agGridOuterDiv">
    <div>
      <div>

        <div class="row topRowMargins headerStyle">

          <div class="dataset col-lg-12" style="margin-top: 1%;">
            Create Dataset
          </div>

        </div>

      </div>

      <div style="margin-top: 25px;">
        <form novalidate [formGroup]='validations_form'>
          <div class="row" style="margin-bottom: 1rem;">

            <div class="col-auto" style="text-align: center;">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Dataset Name</mat-label>
                <input matInput type="text" placeholder="Dataset Name"
                  formControlName="selectdataSet"
                  [(ngModel)]="reportCreationData.datasetname" maxlength="100"
                  required>
                <mat-error *ngFor="let validation of
                  validation_messages.selectdataSet">
                  <span
                    *ngIf="validations_form.get('selectdataSet').hasError(validation.type)
                    && (validations_form.get('selectdataSet').dirty ||
                    validations_form.get('selectdataSet').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-auto" style="text-align: center;">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Description</mat-label>
                <input matInput type="text" placeholder="Description"
                  formControlName="description"
                  [(ngModel)]="reportCreationData.description" maxlength="100"
                  required>
                <mat-error *ngFor="let validation of
                  validation_messages.description">
                  <span
                    *ngIf="validations_form.get('description').hasError(validation.type)
                    && (validations_form.get('description').dirty ||
                    validations_form.get('description').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

           <div class="col" style="text-align: center;">
  <mat-form-field appearance="outline">
    <mat-label i18n="@@DataLakeType">Data Lake Type</mat-label>
    <mat-select [(ngModel)]="reportCreationData.datalakeType"
                formControlName="dataLakeType"
                required>
      <mat-option *ngFor="let lake of dataLakeTypes" [value]="lake.value">
        {{lake.name}}
      </mat-option>
    </mat-select>
    <mat-error *ngFor="let validation of validation_messages.dataLakeType">
      <span *ngIf="validations_form.get('dataLakeType').hasError(validation.type)
                  && (validations_form.get('dataLakeType').dirty ||
                      validations_form.get('dataLakeType').touched)">
        {{ validation.message }}
      </span>
    </mat-error>
  </mat-form-field>
</div>
 <!-- Dataset Output Format Dropdown -->
<div class="col" style="text-align: center;">
  <mat-form-field appearance="outline">
    <mat-label i18n="@@DatasetOutputFormat">Dataset output format</mat-label>
    <mat-select [(ngModel)]="datasetOutputFormat"
                formControlName="datasetOutputFormat"
                required>
      <mat-option *ngFor="let format of datasetOutputTypes" [value]="format.value">
        {{format.name}}
      </mat-option>
    </mat-select>
    <mat-error *ngFor="let validation of validation_messages.datasetOutputFormat">
      <span *ngIf="validations_form.get('datasetOutputFormat').hasError(validation.type)
                  && (validations_form.get('datasetOutputFormat').dirty ||
                      validations_form.get('datasetOutputFormat').touched)">
        {{ validation.message }}
      </span>
    </mat-error>
  </mat-form-field>
</div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCFormulaexpression">Group Type</mat-label>
                <mat-select [(ngModel)]="reportCreationData.type"
                  (selectionChange)="changeGroupTypes($event)"
                  formControlName="type" required>
                  <mat-option *ngFor="let eachtype of types"
                    [(value)]="eachtype.type">
                    {{eachtype.type}}
                  </mat-option>
                </mat-select>
                <mat-error *ngFor="let validation of validation_messages.type">
                  <span
                    *ngIf="validations_form.get('type').hasError(validation.type)
                    && (validations_form.get('type').dirty ||
                    validations_form.get('type').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>


            <div class="col">
              <div *ngIf="objectGroup">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@RCFormulaexpression">Object Type</mat-label>
                  <mat-select (selectionChange)="valutGroupcheck($event)"
                    [(ngModel)]="reportCreationData.objectGroup"
                    formControlName="objectGroup" required>
                    <mat-option *ngFor="let eachobjectGroup of vaultGroup"
                    [(value)]="eachobjectGroup.objectGroupId">
                      {{eachobjectGroup.objectGroupName}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngFor="let validation of
                    validation_messages.objectGroup">
                    <span
                      *ngIf="validations_form.get('objectGroup').hasError(validation.type)
                      && (validations_form.get('objectGroup').dirty ||
                      validations_form.get('objectGroup').touched)">
                      {{ validation.message }}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div *ngIf="datasetGroup">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@RCFormulaexpression">Dataset Group</mat-label>
                  <mat-select (selectionChange)="valutGroupcheck($event)"
                    [(ngModel)]="reportCreationData.objectGroup"
                    formControlName="objectGroup" required>
                    <mat-option>None</mat-option>
                    <mat-option *ngFor="let eachobjectGroup of datasetGroups"
                      [(value)]="eachobjectGroup.datasetGroupId">
                      {{eachobjectGroup.datasetGroupName}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngFor="let validation of
                    validation_messages.objectGroup">
                    <span
                      *ngIf="validations_form.get('objectGroup').hasError(validation.type)
                      && (validations_form.get('objectGroup').dirty ||
                      validations_form.get('objectGroup').touched)">
                      {{ validation.message }}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>


            </div>
          </div>
        </form>
      </div>
      <div class="row">
        <div style="width: 32%;">
          <div class="seperateDiv">
            <ag-grid-angular class="ag-theme-balham table-width-fields
              tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForObjects" [animateRows]="true"
              [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
              [rowSelection]="rowSelection" [rowHeight]="35" [headerHeight]="35"
              [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
              [enableRangeSelection]="true" [debug]="true"
              (gridReady)="onGridReadyForObjects($event,value)"
              (cellClicked)="cellClickedObjects($event)" [hidden]="!true">
            </ag-grid-angular>
          </div>
        </div>

        <div style="width: 1%;">

        </div>

        <div style="width: 32%;">
          <div class="seperateDiv">
            <ag-grid-angular class="ag-theme-balham table-width-fields
              tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForTablesFields" [animateRows]="true"
              [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
              [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35"
              [headerHeight]="35" [enableBrowserTooltips]="true"
              [floatingFiltersHeight]="45" [enableRangeSelection]="true"
              [debug]="true" [components]="components"
              (gridReady)="onGridReadyForTablesFields($event,ngModelObjectTemporary,
              'test')"
              (rowSelected)="onRowSelected($event)" [hidden]="!true">
            </ag-grid-angular>
          </div>
        </div>

        <div style="width: 2%;margin: auto;font-size: 1.8rem;text-align:
          center;">
          <div>
            <div (click)="pushDataToSelectedFieldsGrid('insert')">
              <em class="fas fa-step-forward" title="Move selected rows to
                Right"></em>
            </div>
            <div (click)="pushDataToSelectedFieldsGridComplete()">
              <em class="fas fa-forward" title="Move all rows to Right"></em>
            </div>
            <div (click)="popDataToSelectedFieldsGridComplete()">
              <em class="fas fa-backward" title="Move all rows to Left"></em>
            </div>
            <div (click)="popDataToSelectedFieldsGrid()">
              <em class="fas fa-step-backward" title="Move selected rows to
                Left"></em>
            </div>
            <div (click)="groupConcat()">
              <em class="fas fa-link" title="Concatenate Selected fields"></em>
            </div>
            <div (click)="unGroupConcat()">
              <em class="fas fa-unlink" title="UnConcatenate Selected fields"></em>
            </div>
          </div>
        </div>

        <div style="width: 32%;">
          <div class="seperateDiv">
            <ag-grid-angular class="ag-theme-balham table-width-fields
              tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForSelectedFields"
              [defaultColDef]="defaultColDef" [animateRows]="true"
              [rowDragManaged]="true"
              (rowDragEnter)="onRowDragEnter($event)"
              (rowDragEnd)="onRowDragEnd($event)"
              (rowDragMove)="onRowDragMove($event)"
              (rowDragLeave)="onRowDragLeave($event)"
              [sortingOrder]="sortingOrder"
              [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35"
              [headerHeight]="35"
              (gridReady)="onGridReadyForSelectedTableFields($event,ngModelObjectTemporary)"
              (rowSelected)="onRowSelectedToRemove($event)"
              (cellEditingStarted) = "onCellEditingStarted($event)"
              (cellValueChanged)="onCellValueChanged($event)" [hidden]="!true">
            </ag-grid-angular>
          </div>
        </div>

      </div>

      <div style="
        margin-bottom: 2em;"></div>

      <mat-expansion-panel [expanded]="false" style="border-radius: 0.8vh 0.8vh 0
        0; box-shadow: none;">
        <mat-expansion-panel-header style="max-height: 50px; background: rgb(228
          227 230 / 41%);border: 1px solid #a9a9a9a8;">
          <mat-panel-title>
            <label style="font-size: 22px; font-weight: 500; margin-top: 10px;"
              i18n="@@spmsUserReg" class="textColour">Dataset Creation Options</label>
            <span class="example-spacer"></span>
          </mat-panel-title>
          <mat-panel-description>

          </mat-panel-description>
        </mat-expansion-panel-header>

        <div style="margin-top: 3%;">
          <div class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                <div class="row topRowMargins">
                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Transformation <em class="fas fa-gears"
                      style="font-size:20px"></em></label>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row" *ngIf="showTransform" style="margin-top:
                -30px;margin-bottom: 30px;">
                <div class="table-responsive">
                  <table class="table"><caption></caption>
                    <thead>
                      <tr>
                        <th class="th-lg">Object</th>
                        <th class="th-lg">Key</th>
                        <th class="th-lg">Reference Objects</th>
                        <th class="th-lg">SQL</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let transformationObject of transformation; let k= index;">
                        <td class="conditionsalign">{{transformationObject.object}}</td>
                        <td class="conditionsalign">{{transformationObject.attribute}}</td>
                        <td class="conditionsalign">{{transformationObject.referenceObjects}}</td>
                        <td class="conditionsalign">{{transformationObject.sql}}</td>
                        <td class="conditionsalign" style="text-align: end;
                          padding-right: 33px;"><label class="CloseButtonStyle"><span>
                              <em (click)="deleteTransformation(k)" class="fas fa-minus"
                                style="color: white;" title="Remove"></em></span></label></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <form novalidate [formGroup]="transformationFormGroup">
              <div>
                <div class="row topRowMargins" style="margin-top: -25px;">
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Objects</mat-label>
                      <mat-select [(ngModel)]="transformationObjectData.object"
                        (selectionChange)="onTransformationObjectSelection($event)"
                        formControlName="transformationObject">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of filterObjects"
                          [(value)]="field.object">
                          {{field.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Attributes</mat-label>
                      <mat-select
                      [ngModel]="transformationField"
                      (ngModelChange)="onAttributeChange($event)"
                      name="transformationAttribute">

                      <mat-option *ngFor="let field of filterData" [value]="field">
                        {{ field.alias }}
                      </mat-option>

                    </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Reference Objects</mat-label>
                      <mat-select [(ngModel)]="transformationReferenceList"
                        formControlName="transformationReference"
                        (selectionChange)="onTransformationReferenceObjectSelection($event)" multiple>
                        <mat-option *ngFor="let referenceObject of referenceObjects"
                          [(value)]="referenceObject.objectname">
                          {{referenceObject.object}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field class="valueField" appearance="outline">
                      <mat-label i18n="@@RCEnterValue">Enter SQL</mat-label>
                      <textarea matInput placeholder="Enter SQL" formControlName="transformationSql"
                      [(ngModel)]="transformationObjectData.sql" cdkTextareaAutosize cdkAutosizeMinRows="1"></textarea>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-1">
                    <div>
                      <label (click)="addTransformation()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add"></em></label>
                    </div>
                  </div>
                </div>
              </div>
            </form>

          </div>
        </div>

        <div>
          <div class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                <div class="row topRowMargins">

                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Rolling Up <em class="fas fa-link"
                      style="font-size:20px"></em></label>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row" *ngIf="showRollingUp" style="margin-top:
                -30px;margin-bottom: 30px;">
                <div class="table-responsive" *ngIf="showRollingUp">
                  <table class="table" style="font-weight: bold;"><caption></caption>
                    <thead>
                      <tr>
                        <th class="th-lg">Parent Object </th>
                        <th class="th-lg">Parent Object Attributes</th>
                        <th class="th-lg">Child Object</th>
                        <th class="th-lg">Child Object Attributes</th>
                        <th class="th-lg">RollupAlias</th>
                         <th class="th-lg">Rollup Separator</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let eachrollingup of rollingUp; let k=
                        index;">
                        <td class="conditionsalign">{{eachrollingup.parentObjectName}}</td>
                        <td class="conditionsalign">{{eachrollingup.parentAttributesalias}}</td>
                        <td class="conditionsalign">{{eachrollingup.childObjectName}}</td>
                        <td class="conditionsalign">{{eachrollingup.childAttributesalias}}</td>
                        <td class="conditionsalign" >{{eachrollingup.rollupColumnAlias}}</td>
                        <td class="conditionsalign" >{{eachrollingup.rollupseprator}}</td>
                        <td class="conditionsalign"><label
                            class="CloseButtonStyle"><span>
                              <em (click)="deleteRollingUp(k)" class="fas
                                fa-minus"
                                style="color: white;" title="Remove"></em></span></label></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row topRowMargins" style="margin-top: -25px;">
              <div class="col-lg-2">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@RCFields">Rollup Exclusion Object</mat-label>
                  <mat-select [(ngModel)]="rollupExclusionObjects" multiple
                    (selectionChange)="rollupExclusionObjectSelection()">
                    <mat-option *ngFor="let field of filterObjects"
                      [(value)]="field.object">
                      {{field.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <form novalidate [formGroup]="formValidAttributes">
              <div>
                <!-- ========================== ROW 1 =============================== -->
<div class="row topRowMargins" style="margin-top: -25px;">

  <!-- Parent Object -->
  <div class="col-lg-2">
    <mat-form-field appearance="outline">
      <mat-label>Parent Object</mat-label>
      <mat-select [(ngModel)]="rollingupdata.parentObjectName"
                  formControlName="datasetNameone"
                  (selectionChange)="changeRollingUpDatasetNameOne($event)">
        <mat-option *ngFor="let field of filterObjects" [value]="field.object">
          {{field.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Parent Attributes -->
  <div class="col-lg-2">
    <mat-form-field appearance="outline">
      <mat-label>Attributes</mat-label>
      <mat-select [(ngModel)]="parentattribute"
                  formControlName="attributes"
                  (selectionChange)="changeRollingUpParentAttributes($event)">
        <mat-option *ngFor="let field of datasetOneAttributes; let i = index"
                    [value]="datasetOneAttributes[i]">
          {{field.attributeNameWithFields}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Child Object -->
  <div class="col-lg-2">
    <mat-form-field appearance="outline">
      <mat-label>Child Object</mat-label>
      <mat-select [(ngModel)]="rollingupdata.childObjectName"
                  formControlName="datasetNametwo"
                  (selectionChange)="changeRollingUpDatasetNameTwo($event)">
        <mat-option *ngFor="let field of filterObjects" [value]="field.object">
          {{field.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Child Attributes -->
  <div class="col-lg-2">
    <mat-form-field appearance="outline">
      <mat-label>Attributes</mat-label>
      <mat-select [(ngModel)]="rollingupdatatemp.childattributes"
                  formControlName="attributestwo"
                  (selectionChange)="changeRollingUpChildAttributes($event)">
        <mat-option *ngFor="let attr of datasetTwoAttributes; let i = index"
                    [value]="datasetTwoAttributes[i]">
          {{attr.attributeNameWithFields}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

</div>


<!-- ========================== ROW 2 =============================== -->
<div class="row" style="margin-top:-25px;">

  <!-- RollingUp Alias -->
  <div class="col-lg-2">
    <mat-form-field appearance="outline">
      <mat-label>RollingUp Alias</mat-label>
      <input matInput type="text"
             placeholder="{{rollingupdata.rollupColumnAlias}}"
             [(ngModel)]="rollingupdata.rollupColumnAlias"
             formControlName="constant"
             (input)="onRollupAliasChange($event.target.value)">
    </mat-form-field>
  </div>

  <!-- Separator -->
  <div class="col-lg-2">
    <mat-form-field appearance="outline">
      <mat-label>Separator</mat-label>
      <mat-select [(ngModel)]="rollingupdata.rollupseprator"
                  name="rollupSeparator"
                  formControlName="rollupSeparator"
                  (selectionChange)="onSeparatorSelect($event)">
        <mat-option *ngFor="let sep of rollupSeparatorList"
                    [value]="sep.rollupseperatorvalue">
          {{ sep.rollupseparator }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

 <div class="col-lg-1" style="display: inline-flex;
                    justify-content: space-between;">
                    <label (click)="addRollingup()" style="margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;"><em class="fas fa-plus" style="color:
                        antiquewhite;font-size: large;" title="Add"></em></label>
                    <div style="margin-left: 1rem;margin-top: .4rem;">
                      <mat-checkbox class="mat-checkbox-layout" ngDefaultControl
                        [(ngModel)]="applyRecordFilter" [checked] = "applyRecordFilter" (change)="applyRecordFilterSelection()">Apply
                        Record Filter?</mat-checkbox>
                    </div>
                  </div>
                

</div>

                <div *ngIf="applyRecordFilter" class="row topRowMargins"
                  style="margin-top: -10px;">
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Child Object</mat-label>
                      <input matInput readonly type="text" [value]="rollingupdata.childObjectName"
                        formControlName="selectedChildDataSet"
                        [(ngModel)]="rollingupdata.childObjectName">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Filter Criteria</mat-label>
                      <mat-select [(ngModel)]="recordfilterData.fieldsWhere"
                        formControlName="fieldsWhere"
                        (selectionChange)="recordLevelAttrbuteSelection($event)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of recordLevelFilterData"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Condition</mat-label>
                      <mat-select
                        [(ngModel)]="recordfilterData.conditionalOperatorWhere"
                        formControlName="recordConditionalOperatorWhere"
                        (selectionChange)="recordFilterCondition($event)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let conditionalOperator of
                          conditionalOperatorDataWhere"
                          [(value)]="conditionalOperator.value">
                          {{conditionalOperator.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <div *ngIf="recordBetweenField">
                      <div *ngIf="recordMultiField" style="display: inline-flex;
                        justify-content: space-between; max-width: 100%;">
                        <mat-form-field class="valueField" appearance="outline">
                          <mat-label i18n="@@RCEnterValue">Enter Start Value</mat-label>
                          <input matInput type="text" maxlength="50"
                            formControlName="enterValueWhere"
                            [(ngModel)]="recordfilterData.enterValueBetweenStart">
                        </mat-form-field>
                        <mat-form-field class="valueField" appearance="outline"
                          style="margin-left: 1rem;">
                          <mat-label i18n="@@RCEnterValue">Enter End Value</mat-label>
                          <input matInput type="text" maxlength="50"
                            formControlName="enterValueWhere"
                            [(ngModel)]="recordfilterData.enterValueBetweenEnd">
                        </mat-form-field>
                      </div>
                      <div *ngIf="recordMultiDate" style="display: inline-flex;
                        justify-content: space-between; max-width: 100%;">
                        <mat-form-field appearance="outline">
                          <mat-label i18n="@@TMSTAFFMASTERLastname">Select Start
                            Date</mat-label>
                          <input matInput
                            [(ngModel)]="recordfilterData.enterValueBetweenStart"
                            [matDatepicker]="recordDate1"
                            readonly formControlName="enterValueWhere">
                          <mat-datepicker-toggle matSuffix [for]="recordDate1">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker #recordDate1></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-left:
                          1rem;">
                          <mat-label i18n="@@TMSTAFFMASTERLastname">Select End
                            Date</mat-label>
                          <input matInput
                            [(ngModel)]="recordfilterData.enterValueBetweenEnd"
                            [matDatepicker]="recordDate2"
                            readonly formControlName="enterValueWhere">
                          <mat-datepicker-toggle matSuffix [for]="recordDate2">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker #recordDate2></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>
                    <div *ngIf="recordDateField">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMSTAFFMASTERLastname">Select Date</mat-label>
                        <input matInput
                          [(ngModel)]="recordfilterData.enterValueWhereDate"
                          [matDatepicker]="recordDate"
                          readonly formControlName="enterValueWhere">
                        <mat-datepicker-toggle matSuffix [for]="recordDate">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #recordDate></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div *ngIf="recordValueField">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCEnterValue">Enter Value</mat-label>
                        <input matInput type="text" maxlength="50"
                          formControlName="enterValueWhere"
                          [(ngModel)]="recordfilterData.enterValueWhere">
                      </mat-form-field>
                    </div>
                    <div *ngIf="recordMultiselect">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCFields">Select Values</mat-label>
                        <mat-select [(ngModel)]="recordfilterData.multiSelect" multiple
                          formControlName="recordMultiselect">
                          <mat-option>None</mat-option>
                          <mat-option *ngFor="let field of multiSelectVaules"
                            [(value)]="field.alias">
                            {{field.alias}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-lg-1">
                    <div *ngIf="recordscheduleRange" style="margin-left: -13.5vw;">
                      <label (click)="addRecordFilter()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add Filters"></em></label></div>
                    <div *ngIf="recordBetweenField" style="margin-left: 12.5vw;">
                      <label (click)="addRecordFilter()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add Filters"></em></label></div>
                    <div *ngIf="!recordBetweenField && !recordscheduleRange">
                      <label (click)="addRecordFilter()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add Filters"></em></label>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

        </div>

        <div style="
          margin-bottom: 2em;"></div>

        <div style="margin-left:2%;margin-right:2%">
          <div class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                <div class="row topRowMargins">
                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Column Filters <em class="fas fa-filter"
                      style="font-size:20px"></em></label>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row" *ngIf="showColumnFilter" style="margin-top:
                -30px;margin-bottom: 30px;">

                <div class="table-responsive">
                  <table class="table"><caption></caption>
                    <thead>
                      <tr>
                        <th class="th-lg">Object</th>
                        <th class="th-lg">Key</th>
                        <th class="th-lg">View Conditions</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let whereData of columnFilter; let k= index;">
                        <td class="conditionsalign">{{whereData.object}}</td>
                        <td class="conditionsalign">{{whereData.name}}</td>
                        <td class="conditionsalign" style="
                          padding-right: 33px;"><label style="
                      margin-bottom: auto;
                      padding: 2px 5px 2px 5px;
                      border-radius: 15px;"   [style.background-color]="buttonColor"
        [style.border-color]="buttonColor"><span>
                          <em class="far fa-eye"
                          style="color: white;" title="View Conditions" (click)="openConditionInfo(whereData)"></em>
                        </span></label></td>
                        <td class="conditionsalign" style="
                          padding-right: 33px;"><label class="CloseButtonStyle"><span>
                              <em (click)="deleteColumnFilter(k)" class="fas fa-minus"

                                style="color: white;" title="Remove"></em></span></label></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <form novalidate [formGroup]="columnFilterFormGroup">
              <div>
                <div class="row topRowMargins" style="margin-top: -25px;">
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Column Filter Object</mat-label>
                      <mat-select [(ngModel)]="columnFilterData.object"
                        formControlName="columnObject" (selectionChange)="objectWhereKey($event)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of filterObjects"
                          [(value)]="field.object">
                          {{field.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Column Filter Attribute</mat-label>
                      <mat-select [(ngModel)]="columnFilterData.alias"
                        formControlName="columnAttribute" (selectionChange)="onColumnFilterAttributeSelection($event)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of columnLevelFilterData"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <label (click)="addColumnFilter()" style="margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;"><em class="fas fa-plus"
                        style="color:
                        antiquewhite;font-size: large;" title="Add"></em></label>
                  </div>
                </div>
                <div class="row topRowMargins" style="margin-top: -25px;">
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Objects</mat-label>
                      <mat-select [(ngModel)]="columnFilterDataObject.objectWhere"
                        (selectionChange)="onColumnObjectSelection($event)"
                        formControlName="columnObjectList">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of filterObjects"
                          [(value)]="field.object">
                          {{field.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Attributes</mat-label>
                      <mat-select [(ngModel)]="columnFilterDataObject.fieldsWhere"
                        formControlName="columnObjectAttributes"
                        (selectionChange)="onColumnAttrbuteSelection($event)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of filterData"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Condition</mat-label>
                      <mat-select
                        [(ngModel)]="columnFilterDataObject.conditionalOperatorWhere"
                        formControlName="columnLogicalOperatorWhere"
                        (selectionChange)="onColumnFilterConditionSelection($event)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let conditionalOperator of
                          conditionalOperatorDataWhere"
                          [(value)]="conditionalOperator.value">
                          {{conditionalOperator.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <div *ngIf="columnBetweenField">
                      <div *ngIf="columnValueField" style="display: inline-flex;
                        justify-content: space-between; max-width: 100%;">
                        <mat-form-field class="valueField" appearance="outline">
                          <mat-label i18n="@@RCEnterValue">Enter Start Value</mat-label>
                          <input matInput type="text" maxlength="50"
                            formControlName="columnTextfield"
                            [(ngModel)]="columnFilterDataObject.enterValueBetweenStart">
                        </mat-form-field>
                        <mat-form-field class="valueField" appearance="outline"
                          style="margin-left: 1rem;">
                          <mat-label i18n="@@RCEnterValue">Enter End Value</mat-label>
                          <input matInput type="text" maxlength="50"
                            formControlName="columnTextfield"
                            [(ngModel)]="columnFilterDataObject.enterValueBetweenEnd">
                        </mat-form-field>
                      </div>
                      <div *ngIf="columnDateChange" style="display: inline-flex;
                        justify-content: space-between; max-width: 100%;">
                        <mat-form-field appearance="outline">
                          <mat-label i18n="@@TMSTAFFMASTERLastname">Select Start
                            Date</mat-label>
                          <input matInput
                            [(ngModel)]="columnFilterDataObject.enterValueBetweenStart"
                            [matDatepicker]="whereDate1"
                            readonly formControlName="columnDatefield">
                          <mat-datepicker-toggle matSuffix [for]="whereDate1">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker #whereDate1></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-left:
                          1rem;">
                          <mat-label i18n="@@TMSTAFFMASTERLastname">Select End
                            Date</mat-label>
                          <input matInput
                            [(ngModel)]="columnFilterDataObject.enterValueBetweenEnd"
                            [matDatepicker]="whereDate2"
                            readonly formControlName="columnDatefield">
                          <mat-datepicker-toggle matSuffix [for]="whereDate2">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker #whereDate2></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>
                    <div *ngIf="columnDateField">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMSTAFFMASTERLastname">Select Date</mat-label>
                        <input matInput
                          [(ngModel)]="columnFilterDataObject.enterValueWhereDate"
                          [matDatepicker]="whereDate"
                          readonly formControlName="columnDatefield">
                        <mat-datepicker-toggle matSuffix [for]="whereDate">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #whereDate></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div *ngIf="columnFieldChange">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCEnterValue">Enter Value</mat-label>
                        <input matInput type="text" maxlength="50"
                          formControlName="columnTextfield"
                          [(ngModel)]="columnFilterDataObject.enterValueWhere">
                      </mat-form-field>
                    </div>
                    <div *ngIf="columnMultiselect">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCFields">Select Values</mat-label>
                        <mat-select [(ngModel)]="columnFilterDataObject.multiSelect" multiple
                          formControlName="columnMultiSelect">
                          <mat-option *ngFor="let field of multiSelectVaules"
                            [(value)]="field.alias">
                            {{field.alias}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-lg-1">
                    <div *ngIf="columnScheduleRange" style="margin-left: -14vw;">
                      <label (click)="addFilterForColumn()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add"></em></label></div>
                    <div *ngIf="columnBetweenField" style="margin-left: 12.5vw;">
                      <label (click)="addFilterForColumn()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add"></em></label></div>
                    <div *ngIf="!columnBetweenField && !columnScheduleRange">
                      <label (click)="addFilterForColumn()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add"></em></label>
                    </div>
                  </div>

                </div>
              </div>
            </form>
          </div>
          <!-- OLD code -->
          <div class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                <div class="row topRowMargins">
                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Inclusion Filters <em class="fas fa-filter"
                      style="font-size:20px"></em></label>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row" *ngIf="showFilter" style="margin-top:
                -30px;margin-bottom: 30px;">
                <div class="table-responsive">
                  <table class="table"><caption></caption>
                    <thead>
                      <tr>
                        <th class="th-lg">Object</th>
                        <th class="th-lg">Key</th>
                        <th class="th-lg">Condition</th>
                        <th class="th-lg">Value</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let whereData of where; let k= index;">
                        <td class="conditionsalign">{{whereData.objectWhere}}</td>
                        <td class="conditionsalign">{{whereData.whereKey}}</td>
                        <td class="conditionsalign">{{whereData.whereCondition}}</td>
                        <td class="conditionsalign">{{whereData.whereValue}}</td>
                        <td class="conditionsalign">{{whereData.whereValue1}}</td>
                        <td class="conditionsalign" style="text-align: end;
                          padding-right: 33px;"><label class="CloseButtonStyle"><span>
                              <em (click)="deleteWhere(k)" class="fas fa-minus"
                                style="color: white;" title="Remove"></em></span></label></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <form novalidate [formGroup]="formValidWhere">
              <div>
                <div class="row topRowMargins" style="margin-top: -25px;">
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Objects</mat-label>
                      <mat-select [(ngModel)]="whereData.objectWhere"
                        (selectionChange)="whereKey($event)"
                        formControlName="objectWhere">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of filterObjects"
                          [(value)]="field.object">
                          {{field.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Attributes</mat-label>
                      <mat-select [(ngModel)]="whereData.fieldsWhere"
                        formControlName="fieldsWhere"
                        (selectionChange)="attrbuteSelection($event)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of filterData"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Condition</mat-label>
                      <mat-select
                        [(ngModel)]="whereData.conditionalOperatorWhere"
                        formControlName="conditionalOperatorWhere"
                        (selectionChange)="filterCondition($event)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let conditionalOperator of
                          conditionalOperatorDataWhere"
                          [(value)]="conditionalOperator.value">
                          {{conditionalOperator.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <div *ngIf="betweenField">
                      <div *ngIf="valueField" style="display: inline-flex;
                        justify-content: space-between; max-width: 100%;">
                        <mat-form-field class="valueField" appearance="outline">
                          <mat-label i18n="@@RCEnterValue">Enter Start Value</mat-label>
                          <input matInput type="text" maxlength="50"
                            formControlName="enterValueWhere"
                            [(ngModel)]="whereData.enterValueBetweenStart">
                        </mat-form-field>
                        <mat-form-field class="valueField" appearance="outline"
                          style="margin-left: 1rem;">
                          <mat-label i18n="@@RCEnterValue">Enter End Value</mat-label>
                          <input matInput type="text" maxlength="50"
                            formControlName="enterValueWhere"
                            [(ngModel)]="whereData.enterValueBetweenEnd">
                        </mat-form-field>
                      </div>
                      <div *ngIf="dateChange" style="display: inline-flex;
                        justify-content: space-between; max-width: 100%;">
                        <mat-form-field appearance="outline">
                          <mat-label i18n="@@TMSTAFFMASTERLastname">Select Start
                            Date</mat-label>
                          <input matInput
                            [(ngModel)]="whereData.enterValueBetweenStart"
                            [matDatepicker]="whereDate1"
                            readonly formControlName="enterValueWhere">
                          <mat-datepicker-toggle matSuffix [for]="whereDate1">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker #whereDate1></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-left:
                          1rem;">
                          <mat-label i18n="@@TMSTAFFMASTERLastname">Select End
                            Date</mat-label>
                          <input matInput
                            [(ngModel)]="whereData.enterValueBetweenEnd"
                            [matDatepicker]="whereDate2"
                            readonly formControlName="enterValueWhere">
                          <mat-datepicker-toggle matSuffix [for]="whereDate2">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker #whereDate2></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>
                    <div *ngIf="dateField">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMSTAFFMASTERLastname">Select Date</mat-label>
                        <input matInput
                          [(ngModel)]="whereData.enterValueWhereDate"
                          [matDatepicker]="whereDate"
                          readonly formControlName="enterValueWhere">
                        <mat-datepicker-toggle matSuffix [for]="whereDate">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #whereDate></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div *ngIf="fieldChange">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCEnterValue">Enter Value</mat-label>
                        <input matInput type="text" maxlength="50"
                          formControlName="enterValueWhere"
                          [(ngModel)]="whereData.enterValueWhere">
                      </mat-form-field>
                    </div>
                    <div *ngIf="multiselect">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCFields">Select Values</mat-label>
                        <mat-select [(ngModel)]="whereData.multiSelect" multiple
                          formControlName="multiselect">
                          <mat-option *ngFor="let field of multiSelectVaules"
                            [(value)]="field.alias">
                            {{field.alias}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-lg-1">
                    <div *ngIf="scheduleRange" style="margin-left: -14vw;">
                      <label (click)="addWhere()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add Filters"></em></label></div>
                    <div *ngIf="betweenField" style="margin-left: 12.5vw;">
                      <label (click)="addWhere()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add"></em></label></div>
                    <div *ngIf="!betweenField && !scheduleRange">
                      <label (click)="addWhere()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add"></em></label>
                    </div>
                  </div>

                </div>
              </div>
            </form>
          </div>

          <div class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                <div class="row topRowMargins">

                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Sorting<em class="fas fa-sort" style="
                      font-size: 23px;
                      padding: 0px 0px 0px 6px;"></em></label>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row" *ngIf="showOrderBy" style="margin-top: -30px;
                margin-bottom: 30px;">
                <div class="table-responsive">
                  <table class="table" ><caption></caption>
                    <thead>
                      <tr>
                        <th class="th-lg">Object</th>
                        <th class="th-lg">Key</th>
                        <th class="th-lg">Align</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let eachorder of orderBy;let k= index;">
                        <td class="conditionsalign">{{eachorder.orderObject}}</td>
                        <td class="conditionsalign">{{eachorder.orderKey}}</td>
                        <td class="conditionsalign"   >{{eachorder.orderAllign}}</td>
                        <td class="conditionsalign" style="padding-right: 36px;">
                          <label class="CloseButtonStyle"><span> <em
                                (click)="deleteOrder(k)" class="fas fa-minus"
                                style="color: white;" title="Remove "></em></span></label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <form novalidate [formGroup]="formValidWhere">
              <div>
                <div class="row topRowMargins" style="margin-top: -25px;">

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Attributes</mat-label>
                      <mat-select [(ngModel)]="orderByData.fieldsOrderBy"
                        formControlName="fieldsOrderBy">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of columns"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Sorting</mat-label>
                      <mat-select [(ngModel)]="orderByData.arrangeOrderBy"
                        formControlName="arrangeOrderBy">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let arrange of arrangeDataOrderBy"
                          [(value)]="arrange.value">
                          {{arrange.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-1">
                    <label (click)="addOrderBy()" style="margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;"><em class="fas fa-plus" style="color:
                        antiquewhite;font-size: large;" title="Add"></em></label>
                  </div>
                </div>
              </div>
            </form>
          </div>
<!-- ===================20-11-2024===================================== -->
<div class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
  <div class="row" style="margin-bottom:1rem">
    <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
      <div class="row topRowMargins">

        <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Modify Column Data Type</label>
                    <!-- <em class="fas fa-sort" style="
                                          font-size: 23px;
                                          padding: 0px 0px 0px 6px;"></em> -->
      </div>
    </div>
  </div>

  
  <div class="container">
    <div class="row" *ngIf="showHeaderType" style="margin-bottom: 30px; margin-top: -45px;">
      <div class="table-responsive" *ngIf="showHeaderType">
        <table class="table" style="font-weight: bold;">
          <caption></caption>
          <thead style="font-weight: bolder;">
            <tr>
              <th class="th-lg">Object Name</th>
              <th class="th-lg">Attribute</th>
              <th class="th-lg">Alias</th>
              <th class="th-lg">Data Type</th>
              <th class="th-lg">Remove</th>
            </tr>
          </thead>
          <tbody style="border:none;">
           
            <tr *ngFor="let eachorder of headersTypeArr; let o = index;">
              <td class="conditionsalign">{{ eachorder.headerKeyObject }}</td>
              <td class="conditionsalign">{{ eachorder.headerKey }}</td>
              <td class="conditionsalign">{{ eachorder.headerKeyAlias }}</td>
              <td class="conditionsalign">{{ eachorder.headerKeyType }}</td>
              <td class="conditionsalign">
                <label class="CloseButtonStyle">
                  <span>
                    <em (click)="deleteHeader(o)" class="fas fa-minus" style="color: white;" title="Remove"></em>
                  </span>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <form novalidate [formGroup]="formValidHeaderType">
    <div>
      <div class="row topRowMargins" style="margin-top: -25px;">

        
        <div class="col-lg-1.5">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@RCConditionalOperators">Column Name</mat-label>
            <mat-select [(ngModel)]="headerTypeObj.headerKeyAlias"formControlName="headerKeyAlias" (selectionChange)="onHeaderChangeSelection($event)" multiple>
              <mat-option *ngFor="let referenceObject of columns" [value]="referenceObject.alias">
                <!-- (filteredColumns.length === 0 ? columns : filteredColumns) -->
                {{ referenceObject.alias }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

       
          <div class="col-lg-2">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCFields">Data Type</mat-label>
              <mat-select [(ngModel)]="headerTypeObj.headerKeyType" formControlName="headerKeyType">
                <mat-option>None</mat-option>
                <mat-option *ngFor="let header of arrangeDataByForHeaderType" [(value)]="header.value">
                  {{header.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        <div class="col-lg-1">
          <label (click)="addHeaderType   ()" style="margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;"><em class="fas fa-plus" style="color:
                        antiquewhite;font-size: large;" title="Add"></em></label>

        </div>
      </div>
    </div>
  </form>
</div>

<!-- ===================20-11-2024===================================== -->

          <div class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                <div class="row topRowMargins">

                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Aggregate<em class="fas fa-calculator" style="
                      font-size: 23px;
                      padding: 0px 0px 0px 6px;"></em></label>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row" *ngIf="showAggregate" style=
                "margin-bottom: 30px; margin-top: -45px;" >
                <div class="table-responsive" *ngIf="showAggregate">
                  <table class="table" style="font-weight: bold;"><caption></caption>
                    <thead style="font-weight: bolder;">
                      <tr>
                        <th class="th-lg">Aggregate On</th>
                        <th class="th-lg">Aggregate Function</th>
                        <th class="th-lg">Group By Function</th>
                        <th class="th-lg">Partition On</th>
                        <th class="th-lg">Distinct On</th>
                        <th class="th-lg">Column Alias</th>
                        <th class="th-lg">Aggregation Condition</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let data of aggregateBy;let a=
                        index;">
                        <td class="conditionsalign">{{data.aggregateColumn}}</td>
                        <td class="conditionsalign">{{data.aggregateFunction}}</td>
                        <td class="conditionsalign">{{data.groupByFunction}}</td>
                        <td class="conditionsalign">{{data.partitionByColumn}}</td>
                        <td class="conditionsalign">{{data.distinctColumns}}</td>
                        <td class="conditionsalign">{{data.alias}}</td>
                        <td class="conditionsalign">{{data.conditionalValue}}</td>
                        <td class="conditionsalign">
                          <label class="CloseButtonStyle"><span> <em
                                (click)="deleteAggregate(a)" class="fas
                                fa-minus"
                                style="color: white; "  title="Remove"></em></span></label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <form novalidate [formGroup]="formValidWhere">
              <div>
                <div class="row topRowMargins" style="margin-top: -25px;">


                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Aggregate On</mat-label>
                      <mat-select
                        [(ngModel)]="aggregateByData.aggregateOn"
                        formControlName="aggregateOn">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of columns"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
          

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Aggregate Function</mat-label>
                      <mat-select [(ngModel)]="aggregateByData.aggregateFunction" formControlName="aggregateFunction">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let aggregate of arrangeDataBy" [(value)]="aggregate.value">
                          {{aggregate.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- **************************added by Aman Singh********************     -->
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Group by Function</mat-label>
                      <mat-select [(ngModel)]="aggregateByData.groupByFunction" formControlName="aggregateFunction">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let aggregate of arrangeDataBy" [(value)]="aggregate.value">
                          {{aggregate.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- **************************added by Aman Singh********************     -->
                  <!--
        /*
          * modified by Aman Singh
          * 07/05/2024
          * added 3 new attributes in aggregate
        */
       -->
      <!-- =================================================================================== -->
                  <div class="col-lg-1.5">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Partition On</mat-label>
                      <mat-select [(ngModel)]="aggregateByData.partionOn"
                        formControlName="partionOn"
                        (selectionChange)="onPartitionChangeSelection($event)" multiple>
                        <mat-option *ngFor="let referenceObject of columns"
                          [(value)]="referenceObject.alias">
                          {{referenceObject.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-1.5" style="margin-left:1.5%">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Distinct On</mat-label>
                      <mat-select [(ngModel)]="aggregateByData.distinctColumns"
                        formControlName="orderBy"
                        (selectionChange)="onOrderByChangeSelection($event)" multiple>
                        <mat-option *ngFor="let referenceObject of columns"
                          [(value)]="referenceObject.alias">
                          {{referenceObject.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCLabel">Column Alias</mat-label>
                      <input matInput type="text" maxlength="50" pattern="[a-zA-Z0-9\s\-_]+" title="special character not allowed"
                        formControlName="columnAlias" 
                        [(ngModel)]="aggregateByData.columnAlias">
                      <mat-error *ngFor="let validation of
                        validation_messages.label">
                        <!-- <span
                          *ngIf="formulaFields.get('label').hasError(validation.type)
                          && (formulaFields.get('label').dirty ||
                          formulaFields.get('label').touched)">
                          {{ validation.message }}
                        </span> -->
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCLabel">Aggregation condition</mat-label>
                      <textarea matInput maxlength="500" rows="1" 
                                formControlName="conditionalValue"
                                [(ngModel)]="aggregateByData.conditionalValue">
                      </textarea>
                      <mat-error *ngFor="let validation of validation_messages.label">
                        <!-- You can add your validation messages here -->
                      </mat-error>
                    </mat-form-field>
                  </div>
                  
   <!-- ====================================================================            -->
                  <div class="col-lg-1">
                    <label (click)="addAggregate()" style="margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;"><em class="fas fa-plus" style="color:
                        antiquewhite;font-size: large;" title="Add"></em></label>
                  </div>
                </div>
              </div>
            </form>
          </div>

<!-- *************************************Pivot Aggregate Added by Vijay ******************************** -->
          <div class="container" style="border-bottom: 0.01px ridge
          coral;margin-bottom: 2em;">

            <div class="row" style="margin-bottom:1rem" [formGroup]="formValidPivotType">

              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                <div class="row topRowMargins">

                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Pivot Aggregate</label>
                </div>
              </div>
            </div>
            

             <!-- /**
                 * Renuka chama
                 * Date:08-07-2025
                 * Created pivot type dropdown
                 */ -->

            <div class="row topRowMargins" style="margin-top: -25px; margin-bottom: 1rem;">

    <div class="col-lg-2" [formGroup]="formValidPivotType">

      <mat-form-field appearance="outline">
        <mat-label>Pivot Type</mat-label>
        <mat-select [(ngModel)]="pivotAggregateByData.pivotType" name="pivotType" (selectionChange)="onPivotTypeChange($event.value)" 
        formControlName="pivotType">
          <mat-option value="pivotAggregate">Pivot Aggregate</mat-option>
          <mat-option value="pivotTable">Pivot Table</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>



            <div class="container">
              <div class="row" *ngIf="showPivotAggregate" style=
                "margin-bottom: 30px; margin-top: -45px;" >
                <div class="table-responsive" *ngIf="showPivotAggregate">
                  <table class="table" style="font-weight: bold;"><caption></caption>
                    <thead style="font-weight: bolder;">
                      <tr>
                        <th class="th-lg">Column Alias</th>
                        <th class="th-lg">Case Column</th>
                        <th class="th-lg">Pivot Column</th>
                        <th class="th-lg">Child Columns</th>
                        <th class="th-lg">Headers To Null</th>
                        <th class="th-lg">Order BY Columns</th>
                        <th class="th-lg">Parent Columns</th>
                        <th class="th-lg">Header Value Column</th>

                          <!-- /**
                 * Renuka chama
                 * Date:08-07-2025
                 * Added extra fields for pivot table
                 */ -->
                        <th *ngIf="pivotAggregateByData.pivotType === 'pivotTable'" class="th-lg">Distinct Count</th>
              <th *ngIf="pivotAggregateByData.pivotType === 'pivotTable'" class="th-lg">Pivot Column Alias</th>
              <th *ngIf="pivotAggregateByData.pivotType === 'pivotTable'" class="th-lg">Grand Total Groupby</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <ng-container *ngFor="let data of pivotAggregateBy;let a=
                        index;">
                        <tr *ngIf="data.pivotTable === 'No'">
                         <td class="conditionsalign">{{data.totalAlias}}</td>
                        <td class="conditionsalign">{{data.caseColumn}}</td>
                        <td class="conditionsalign">{{data.pivotColumn}}</td>
                        <td class="conditionsalign">{{data.childColumns}}</td>
                        <td class="conditionsalign">{{data.headersToNull}}</td>
                        <td class="conditionsalign">{{data.orderByColumn}}</td>
                        <td class="conditionsalign">{{data.parentcolumns}}</td>
                        <td class="conditionsalign">{{data.headerValueColumn}}</td>
                        <td *ngIf="pivotAggregateByData.pivotType === 'pivotTable'" class="conditionsalign">{{ data.distinctCount }}</td>
                        <td *ngIf="pivotAggregateByData.pivotType === 'pivotTable'" class="conditionsalign">{{ data.pivotAlias }}</td>
                        <td *ngIf="pivotAggregateByData.pivotType === 'pivotTable'" class="conditionsalign">{{ data.grandTotalGroupby }}</td>
              <td class="conditionsalign" >
        <label class="CloseButtonStyle">
          <span><em (click)="deletePivotAggregate(a)" class="fas fa-minus" style="color: white;" title="Remove"></em></span>
        </label>
      </td>
    </tr>
          <ng-container *ngIf="data.pivotTable === 'Yes'">
      <tr *ngFor="let row of data.pivotMetadata; let b = index">
        <td class="conditionsalign">{{ row.totalAlias }}</td>
        <td class="conditionsalign">{{ row.caseColumn }}</td>
        <td class="conditionsalign">{{ row.pivotColumn }}</td>
        <td class="conditionsalign">{{ row.childColumns }}</td>
        <td class="conditionsalign"></td>
        <td class="conditionsalign">{{ row.orderByColumn }}</td>
        <td class="conditionsalign">{{ row.parentcolumns }}</td>
        <td class="conditionsalign"></td>

        <td class="conditionsalign">{{ row.distinctCount }}</td>
        <td class="conditionsalign">{{ row.pivotColumnAlias.value }}</td>
        <td class="conditionsalign">{{ row.grandTotalGroupby }}</td>

        <td class="conditionsalign">
          <label class="CloseButtonStyle">
            <span><em (click)="deletePivotAggregate(a, b)" class="fas fa-minus" style="color: white;" title="Remove"></em></span>
          </label>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</tbody>
                  </table>
                </div>
              </div>
            </div>
            <form novalidate [formGroup]="formValidPivotType">
              <div>
                
                   <div class="row topRowMargins" style="margin-top: -25px;">
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCLabel">Column Alias</mat-label>
                      <input matInput type="text" maxlength="50" pattern="[a-zA-Z0-9\s\-_]+" title="special character not allowed"
                        formControlName="pivotColumnAlias" 
                        [(ngModel)]="pivotAggregateByData.columnAlias">
                      <mat-error *ngFor="let validation of
                        validation_messages.pivotColumnAlias">

                        <span *ngIf="formValidPivotType.get('pivotColumnAlias').hasError(validation.type) &&
                  (formValidPivotType.get('pivotColumnAlias').dirty || formValidPivotType.get('pivotColumnAlias').touched)">
        {{ validation.message }}
      </span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Case Column</mat-label>
                      <mat-select
                        [(ngModel)]="pivotAggregateByData.caseColumn"
                        formControlName="caseColumn">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of columns"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngFor="let validation of
                        validation_messages.caseColumn">

                        <span *ngIf="formValidPivotType.get('caseColumn').hasError(validation.type) &&
                  (formValidPivotType.get('caseColumn').dirty || formValidPivotType.get('caseColumn').touched)">

        {{ validation.message }}
      </span>
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Pivot Column</mat-label>
                      <mat-select
                        [(ngModel)]="pivotAggregateByData.pivotColumn"
                        formControlName="pivotColumn">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of columns"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngFor="let validation of
                        validation_messages.pivotColumn">

                        <span *ngIf="formValidPivotType.get('pivotColumn').hasError(validation.type) &&
                  (formValidPivotType.get('pivotColumn').dirty || formValidPivotType.get('pivotColumn').touched)">

        {{ validation.message }}
      </span>
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Child Columns</mat-label>
                      <mat-select [(ngModel)]="pivotAggregateByData.childColumns"
                        formControlName="childColumns"
                        (selectionChange)="onOrderByChildColumns($event)" multiple>
                        <mat-option *ngFor="let referenceObject of columns"
                          [(value)]="referenceObject.alias">
                          {{referenceObject.alias}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngFor="let validation of
                        validation_messages.childColumns">

                        <span *ngIf="formValidPivotType.get('childColumns').hasError(validation.type) &&
                  (formValidPivotType.get('childColumns').dirty || formValidPivotType.get('childColumns').touched)">

        {{ validation.message }}
      </span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  
                  <div *ngIf="pivotAggregateByData.pivotType === 'pivotAggregate'" class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Headers To Null</mat-label>
                      <mat-select [(ngModel)]="pivotAggregateByData.headersToNull"
                        formControlName="headersToNull"
                        (selectionChange)="onOrderByorderedHeadersToNull($event)" multiple>
                        <mat-option *ngFor="let referenceObject of columns"
                          [(value)]="referenceObject.alias">
                          {{referenceObject.alias}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngFor="let validation of
                        validation_messages.headersToNull">

                        <span *ngIf="formValidPivotType.get('headersToNull').hasError(validation.type) &&
                  (formValidPivotType.get('headersToNull').dirty || formValidPivotType.get('headersToNull').touched)">

        {{ validation.message }}
      </span>
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Order BY Columns</mat-label>
                      <mat-select [(ngModel)]="pivotAggregateByData.orderByColumn"
                        formControlName="orderByColumn"
                        (selectionChange)="onOrderByorderedOrderByColumn($event)" multiple>
                        <mat-option *ngFor="let referenceObject of columns"
                          [(value)]="referenceObject.alias">
                          {{referenceObject.alias}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngFor="let validation of
                        validation_messages.orderByColumn">

                        <span *ngIf="formValidPivotType.get('orderByColumn').hasError(validation.type) &&
                  (formValidPivotType.get('orderByColumn').dirty || formValidPivotType.get('orderByColumn').touched)">

        {{ validation.message }}
      </span>
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Parent Columns</mat-label>
                      <mat-select [(ngModel)]="pivotAggregateByData.parentcolumns"
                        formControlName="parentcolumns"
                        (selectionChange)="onOrderByorderedParentcolumns($event)" multiple>
                        <mat-option *ngFor="let referenceObject of columns"
                          [(value)]="referenceObject.alias">
                          {{referenceObject.alias}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngFor="let validation of
                        validation_messages.parentcolumns">

                        <span *ngIf="formValidPivotType.get('parentcolumns').hasError(validation.type) &&
                  (formValidPivotType.get('parentcolumns').dirty || formValidPivotType.get('parentcolumns').touched)">

        {{ validation.message }}
      </span>
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div *ngIf="pivotAggregateByData.pivotType === 'pivotAggregate'" class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Header Value Column</mat-label>
                      <mat-select
                        [(ngModel)]="pivotAggregateByData.headerValueColumn"
                        formControlName="headerValueColumn">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of columns"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngFor="let validation of
                        validation_messages.headerValueColumn">

                        <span *ngIf="formValidPivotType.get('headerValueColumn').hasError(validation.type) &&
                  (formValidPivotType.get('headerValueColumn').dirty || formValidPivotType.get('headerValueColumn').touched)">

        {{ validation.message }}
      </span>
                      </mat-error>
                    </mat-form-field>
                  </div>

                    <!-- /**
                 * Renuka chama
                 * Date:08-07-2025
                 * Added extra feilds for pivot table
                 */ -->

                  <div *ngIf="pivotAggregateByData.pivotType === 'pivotTable'" class="col-lg-2">
          <mat-form-field appearance="outline">
            <mat-label>Distinct Count</mat-label>
            <mat-select [(ngModel)]="pivotAggregateByData.distinctCount" formControlName="distinctCount">
              <mat-option value="yes">Yes</mat-option>
              <mat-option value="no">No</mat-option>
            </mat-select>
            <mat-error *ngFor="let validation of
                        validation_messages.distinctCount">

                        <span *ngIf="formValidPivotType.get('distinctCount').hasError(validation.type) &&
                  (formValidPivotType.get('distinctCount').dirty || formValidPivotType.get('distinctCount').touched)">

        {{ validation.message }}
      </span>
                      </mat-error>
          </mat-form-field>
        </div>

         <div *ngIf="pivotAggregateByData.pivotType === 'pivotTable'" class="col-lg-2">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@RCFields">Grand Total Groupby</mat-label>
                   <mat-select
                        [(ngModel)]="pivotAggregateByData.grandTotalGroupby"
                        formControlName="grandTotalGroupby">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of columns"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                       <!-- Modified By Renuka
                         * Date 25-11-2025
                         * Removed mandatory validation for grandtotalgroupby 
                         -->
                   <!-- <mat-error *ngFor="let validation of
                        validation_messages.grandTotalGroupby">

                        <span *ngIf="formValidPivotType.get('grandTotalGroupby').hasError(validation.type) &&
                  (formValidPivotType.get('grandTotalGroupby').dirty || formValidPivotType.get('grandTotalGroupby').touched)">

        {{ validation.message }}
      </span>
                      </mat-error> -->
          </mat-form-field>
        </div>

        
         <!-- <div class="row topRowMargins" *ngIf="pivotAggregateByData.pivotType === 'pivotTable'"> -->
        <div class="col-lg-6"  *ngIf="pivotAggregateByData.pivotType === 'pivotTable'">
          <mat-form-field appearance="outline">
            <mat-label>Pivot Column Alias</mat-label>
            <textarea matInput rows="1" formControlName="pivotAlias" 
                     [(ngModel)]="pivotAggregateByData.pivotAlias"></textarea>
                     <mat-error *ngFor="let validation of
                        validation_messages.pivotAlias">

                        <span *ngIf="formValidPivotType.get('pivotAlias').hasError(validation.type) &&
                  (formValidPivotType.get('pivotAlias').dirty || formValidPivotType.get('pivotAlias').touched)">

        {{ validation.message }}
      </span>
                      </mat-error>
          </mat-form-field>
        </div>
        <!-- </div> -->

        
      

                  <div class="col-lg-1">
                    <label (click)="addPivotAggregate()" style="margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;"><em class="fas fa-plus" style="color:
                        antiquewhite;font-size: large;" title="Add"></em></label>
                   </div>
                   
                    </div>
                    
                    </div>
                    </form>
          </div>
<!-- *************************************Added by Aman ******************************** -->
<div *ngIf="aggregateBy.length >0" class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
  <div class="row" style="margin-bottom:1rem">
    <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
      <div class="row topRowMargins">

        <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Secondary Aggregate<em class="fas fa-calculator" style="
                      font-size: 23px;
                      padding: 0px 0px 0px 6px;"></em></label>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row" *ngIf="showSubLevelAggregate" style="margin-bottom: 30px; margin-top: -45px;">
      <div class="table-responsive" *ngIf="showSubLevelAggregate">
        <table class="table" style="font-weight: bold;">
          <caption></caption>
          <thead style="font-weight: bolder;">
            <tr>
              
              <th class="th-lg">Group By Column</th>
              <th class="th-lg">Alias</th>
              <th class="th-lg">Remove</th>
              
            </tr>
          </thead>
          <tbody style="border:none;">
            <tr *ngFor="let data of subLevelAggregateBy;let k=
                        index;">
              
              <td class="conditionsalign">{{data.groupByColumn}}</td>
              <td class="conditionsalign">{{data.alias}}</td>
              
             
              <td class="conditionsalign">
                <label class="CloseButtonStyle"><span> <em (click)="deleteSubLevelAggregate(k)" class="fas
                                fa-minus" style="color: white;" title="Remove"></em></span></label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <form novalidate [formGroup]="formValidWhere">
    <div>
      <div class="row topRowMargins" style="margin-top: -25px;">


       
        
        <!-- =================================================================================== -->
        
        <div class="col-lg-6" style="margin-left:1.5%" >
          <mat-form-field  appearance="outline" >
            <mat-label i18n="@@RCConditionalOperators">Group By Column</mat-label>
            <mat-select [(ngModel)]="subAggregateLevelData.groupByColumn" formControlName="groupBysecondary"
              (selectionChange)="onOrderByChangeSelection($event)" multiple>
              <mat-option  *ngFor="let referenceObject of columns" [(value)]="referenceObject.alias">
                {{referenceObject.alias}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
<div class="col-lg-2">
  <mat-form-field appearance="outline">
    <mat-label i18n="@@RCLabel">Alias</mat-label>
    <input matInput type="text" maxlength="50" pattern="[a-zA-Z0-9\s\-_]+" title="special character not allowed"
      formControlName="goupByColumnAlias" [(ngModel)]="subAggregateLevelData.alias">
    <mat-error *ngFor="let validation of
                        validation_messages.label">
      <!-- <span
                          *ngIf="formulaFields.get('label').hasError(validation.type)
                          && (formulaFields.get('label').dirty ||
                          formulaFields.get('label').touched)">
                          {{ validation.message }}
                        </span> -->
    </mat-error>
  </mat-form-field>
</div>
        
       
        <!-- ====================================================================            -->
        <div class="col-lg-1" >
          <label (click)="addSubAggregateLevel()" style="margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;"><em class="fas fa-plus" style="color:
                        antiquewhite;font-size: large;" title="Add"></em></label>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- ***************************************************************************** -->
          <!-- Formula Field Section -->
          <div [hidden]="true" class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2.5em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-top: -30px;">
                <div class="row topRowMargins">

                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Formula Attributes<em class="fas fa-file"
                      style=" font-size: 23px;
                      padding: 0px 0px 0px 6px;"></em></label>
                </div>
              </div>
            </div>
            <form novalidate [formGroup]="formulaFields" style="margin-bottom:
              1em;">
              <div class="row">
                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCLabel">Label</mat-label>
                    <input matInput type="text" maxlength="50"
                      formControlName="label"
                      [(ngModel)]="formulaFieldsByData.labelformulafieldsBy">
                    <mat-error *ngFor="let validation of
                      validation_messages.label">
                      <span
                        *ngIf="formulaFields.get('label').hasError(validation.type)
                        && (formulaFields.get('label').dirty ||
                        formulaFields.get('label').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCReturntype">Return Type</mat-label>
                    <mat-select
                      [(ngModel)]="formulaFieldsByData.returntypeformulafieldsBy"
                      formControlName="returntype">
                      <mat-option value="textbox">Text</mat-option>
                      <mat-option value="textbox">Number</mat-option>
                      <mat-option value="Date">Date</mat-option>
                      <mat-option value="Yes/No">Yes/No</mat-option>
                      <mat-option value="DateTime">DateTime</mat-option>
                      <mat-option value="Icon">Icon</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCObject">Fields</mat-label>
                    <mat-select
                      [(ngModel)]="formulaFieldsByData.objectformulafieldsBy"
                      formControlName="object">
                      <mat-option>None</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCFunctions">Functions</mat-label>
                    <mat-select
                      [(ngModel)]="formulaFieldsByData.functionsformulafieldsBy"
                      formControlName="functions">
                      <mat-option>None</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCOprations">Operations</mat-label>
                    <mat-select
                      [(ngModel)]="formulaFieldsByData.oprationsformulafieldsBy"
                      formControlName="oprations">
                      <mat-option>None</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-1">
                  <label style="margin-top: 6px;
                    background: green;
                    margin-bottom: auto;
                    padding: 2px 5px 0px 5px;
                    border-radius: 15px;">
                    <em class="fas fa-plus" style="color: antiquewhite;font-size:
                      large;" title="Add Formula"></em>
                  </label>

                </div>

              </div>
            </form>


          </div>
          <!-- Formula Field Section End -->
        </div>

      </mat-expansion-panel>

      <!--
        /*
          * modified by Ashwin M
          * 28/02/2024
          * additional checkbox for auto refresh dataset flag
        */
       -->
       <div class="col-lg">
        <div class="container" style="text-align: center;">
          <div class="row topRowMargins">
            <div class="col-lg-2" style="margin-left: 10rem;">
              <mat-checkbox class="mat-checkbox-layout" ngDefaultControl
              [(ngModel)]="generateDefaultTemplate" style="margin-top: 1.5vh;">Initiate
              Template Creation</mat-checkbox>
              <mat-checkbox class="mat-checkbox-layout" ngDefaultControl
              [(ngModel)]="autoRefreshDataset">Auto-Refresh Dataset</mat-checkbox>
            </div>
            <div style="margin-left: 5rem; display: flex;justify-content: space-evenly; width: 40%; height:fit-content; margin-top: 1rem;" >
              <button i18n="@@TMRunButton" type="button"
                (click)="createreport()"
                [style.background-color]="buttonColor"
                class="actionButton btn btn-rounded-button z-depth-1
                waves-effect waves-light text-capitalize" style="padding:
                .3rem 1.6rem;font-size: .85rem;width:100%;" id="101">{{butttonname}}</button>
              <button i18n="@@TMRunButton" type="button" (click)="cancel()"
                [style.border-color]="buttonColor"
                class="cancelButton btn btn-rounded-button z-depth-1
                waves-effect waves-light text-capitalize" style="padding:
                .3rem 1.6rem;font-size: .85rem;width:100%;">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div>
      <mat-toolbar class="agGridtoperDiv card" style="
        background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
        border-right: 1px solid #a9a9a9a8;
        border-left: 1px solid #a9a9a9a8;">
        <label i18n="@@spmsUserReg" class="textColour">Datasets</label>
        <span class="example-spacer"></span>
        <button class="refreshrunButton popup gridColour btn btn-rounded-button
          z-depth-1 waves-effect waves-light text-capitalize"
          [style.background-color]="buttonColor" title="Refresh"
          (click)="refreshRun()">
          Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh"
            title="Refresh"></em>
        </button>
       <!-- Export Button -->
<!-- <button class="refreshrunButton popup gridColour btn btn-rounded-button
z-depth-1 waves-effect waves-light text-capitalize"
[style.background-color]="buttonColor" title="Import Data"
(click)="importData()" id="102">
Import
<em class="fas fa-download" style="padding-left: 10px;" title="Import Data"></em>
</button> -->
  <app-common-button  label="Import Data" title="Import Data" icon="fas fa-download"
             [buttonId]="102" [critical]="true" width="100px"(clicked)="importData()">
  </app-common-button>
<!-- Import Button -->
<button class="refreshrunButton popup gridColour btn btn-rounded-button
z-depth-1 waves-effect waves-light text-capitalize"
[style.background-color]="buttonColor" title="Export Data" 
(click)="exportData()" id="103">
Export
<em class="fas fa-upload" style="padding-left: 10px;" title="Export Data" ></em>
</button>

        <button class="popup gridColour btn btn-rounded-button z-depth-1
          waves-effect waves-light text-capitalize"
          [style.background-color]="buttonColor" title="Download"
          (click)="onBtExport()">Download
          <em style="padding: 0px 0px 0px 10px;" class="fas fa-download
            example-icon" title="Download"></em>
        </button>
        <div class="insertPageNoDiv">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
            <input matInput type="text"
              (input)="onSearchChange($event.target.value)">
          </mat-form-field>
        </div>

        <div class="selectRecordsDiv" style="width:9.5%">
          <mat-form-field appearance="outline" style="width:100%">
            <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
            <mat-select [(ngModel)]="pagesize"
              (ngModelChange)="onPageSizeChanged(value)">
              <mat-option value="10" selected>10</mat-option>
              <mat-option value="200">200</mat-option>
              <mat-option value="300">300</mat-option>
              <mat-option value="400">400</mat-option>
            </mat-select>

          </mat-form-field>
        </div>
        <div class="card pagination paginationFirstButton
          paginationFirstlastButton">
          <em class="fas fa-angle-double-left waves-effect waves-light"
            (click)="onBtFirst()"></em>
        </div>
        <div class="card pagination paginationButtons btn-rounded">
          <ul>
            <li class="paginationliicon"><em class="fas fa-angle-left
                waves-effect waves-light"
                (click)="onBtPrevious()"></em></li>
            <li>{{currentpage}}/{{totalpages}}</li>
            <li class="paginationliicon" style="padding:0;"><em
                class="fas fa-angle-right waves-effect waves-light"
                (click)="onBtNext()"></em></li>
          </ul>
        </div>
        <div class="card pagination paginationLastButton
          paginationFirstlastButton">
          <em class="fas fa-angle-double-right waves-effect waves-light"
            (click)="onBtLast()"></em>
        </div>
      </mat-toolbar>
    </div>
    <ag-grid-angular class="ag-theme-balham table-width tablestyles square
      scroolbar-dusty-grass square thin"
      [columnDefs]="columnDefs" [animateRows]="true"
      [pagination]="true" [defaultColDef]="defaultColDef"
      [suppressPaginationPanel]="true" [rowHeight]="35"
      [headerHeight]="35" [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45"
      [paginationPageSize]="paginationPageSize"
      [paginationNumberFormatter]="paginationNumberFormatter"
      [enableRangeSelection]="true" [debug]="true"
      [rowClassRules]="rowClassRules"
      [getRowStyle]="getRowStyle"
      (paginationChanged)="onPaginationChanged()"
      [components]="components"
      (gridReady)="onGridReady($event)" [hidden]="!true">
    </ag-grid-angular>
  </div>
</div>